import React from 'react';
import { withStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import { Slide } from '@mui/material';

const Panel: any = withStyles({
  root: {
    position: 'fixed',
    maxWidth: 1130,
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1101,
    backgroundColor: 'white',
    boxShadow: '0 1px 0 0 rgba(91, 101, 117, 0.15)',
  },
})(Container);

const Component = ({ children }) => {
  return (
    <Slide direction="left" in>
      <Panel disableGutters>{children}</Panel>
    </Slide>
  );
};

export default Component;
